// import React from 'react';

// import styled from 'styled-components';

export const fieldEnabled = ['FieldRadio', {
  name: 'adminStyle.enabled',
  label: null,
  choices: [
    { label: 'Enabled', value: true },
    { label: 'Disabled', value: false },
  ],
  hidden: [() => true],
  block: true,
}]

export const fieldLogoSidebar = ['FieldUploadRefs', {
  name: 'adminStyle.logoSidebar',
  label: 'Primary Logo',
  accept: 'image/png,image/webp,image/*',
  transformations: [
    ['GM', { command: 'compress', maxWidth: 800 }],
    ['GM', { command: 'webp' }],
  ],
  col: 1,
}];

export const fieldLogoLogin = ['FieldUploadRefs', {
  name: 'adminStyle.logoLogin',
  label: 'Login Logo',
  accept: 'image/png,image/webp,image/*',
  transformations: [
    ['GM', { command: 'compress', maxWidth: 800 }],
    ['GM', { command: 'webp' }],
  ],
  col: 1,
}];

export const fieldLogoEmail = ['FieldUploadRefs', {
  name: 'adminStyle.logoEmail',
  label: 'Email Logo',
  accept: 'image/png,image/webp,image/jpeg',
  transformations: [
    ['GM', { command: 'compress', maxWidth: 800 }],
    ['GM', { command: 'webp' }],
  ],
  col: 1,
}];

export const fieldFavicon = ['FieldUploadRefs', {
  name: 'adminStyle.favicon',
  label: 'Favicon',
  accept: 'image/png,image/webp,image/*',
  transformations: [
    ['GM', { command: 'compress', maxWidth: 300 }],
  ],
  col: 1,
}];

export const fieldColorPrimary = ['FieldColorPicker', {
  name: 'adminStyle.colorPrimary',
  label: 'Primary Color',
  disableAlpha: true,
}];

export const fieldColorSecondary = ['FieldColorPicker', {
  name: 'adminStyle.colorSecondary',
  label: 'Secondary Color',
  disableAlpha: true,
}];

export const fieldColorTitle = ['FieldColorPicker', {
  name: 'adminStyle.colorTitle',
  label: 'Title Color',
  disableAlpha: true,
  col: 12,
}];

export const fieldColorButton = ['FieldColorPicker', {
  name: 'adminStyle.colorButton',
  label: 'Button Color',
  disableAlpha: true,
  col: 12,
}];

export const fieldColorBackgroundPrimary = ['FieldColorPicker', {
  name: 'adminStyle.colorBackgroundPrimary',
  label: 'Background Primary',
  disableAlpha: true,
  col: 12,
}];

export const fieldColorBackgroundSecondary = ['FieldColorPicker', {
  name: 'adminStyle.colorBackgroundSecondary',
  label: 'Background Secondary',
  disableAlpha: true,
  col: 12,
}];

export const fieldCss = ['FieldCodeEditor', {
  name: 'adminStyle.css',
  label: 'Custom CSS',
}];

export const fieldColorEmail = ['FieldColorPicker', {
  name: 'adminStyle.colorEmail',
  label: 'Email Color',
  disableAlpha: true,
}];

export const fieldEmailSenderName = ['FieldText', {
  name: 'adminStyle.emailSenderName',
  label: 'Email Sender Name',
}];

export const fieldEmailSenderEmail = ['FieldText', {
  name: 'adminStyle.emailSenderEmail',
  label: 'Email Sender Email',
}];

export const fieldEmailReportEmail = ['FieldText', {
  name: 'adminStyle.emailReportEmail',
  label: 'Email Report Email',
}];

export const FIELDS = [
  // fieldEnabled,
  fieldLogoSidebar,
  fieldLogoLogin,
  // fieldLogoEmail,
  fieldFavicon,
  fieldColorPrimary,
  fieldColorSecondary,
  fieldColorTitle,
  fieldColorButton,
  fieldColorBackgroundPrimary,
  fieldColorBackgroundSecondary,
  fieldCss,
  // fieldColorEmail,
  // fieldEmailSenderName,
  // fieldEmailSenderEmail,
  // fieldEmailReportEmail,
];
